/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnEventStatus } from './en-event-status';
import { EnEventType } from './en-event-type';
 /**
 *
 *
 * @export
 * @interface CalendarEventDto
 */
export interface CalendarEventDto {

    /**
     * @type {number}
     * @memberof CalendarEventDto
     */
    id: number;

    /**
     * Event title (already falls back to the session title)
     *
     * @type {string}
     * @memberof CalendarEventDto
     */
    title: string;

    /**
     * ISO 8601
     *
     * @type {string}
     * @memberof CalendarEventDto
     */
    start: string;

    /**
     * ISO 8601
     *
     * @type {string}
     * @memberof CalendarEventDto
     */
    end: string | null;

    /**
     * @type {boolean}
     * @memberof CalendarEventDto
     */
    allDay: boolean;

    /**
     * @type {EnEventStatus}
     * @memberof CalendarEventDto
     */
    status: EnEventStatus;

    /**
     * @type {EnEventType}
     * @memberof CalendarEventDto
     */
    type: EnEventType;

    /**
     * Expected total duration in seconds
     *
     * @type {number}
     * @memberof CalendarEventDto
     */
    duration: number;

    /**
     * Patient (assignment.user) id
     *
     * @type {number}
     * @memberof CalendarEventDto
     */
    userId: number;

    /**
     * @type {number}
     * @memberof CalendarEventDto
     */
    assignmentId: number;

    /**
     * Soft-delete timestamp (ISO 8601); the client filters on it
     *
     * @type {string}
     * @memberof CalendarEventDto
     */
    deleted: string | null;

    /**
     * Groups related events (e.g. all sessions of one therapy)
     *
     * @type {string}
     * @memberof CalendarEventDto
     */
    groupId: string | null;

    /**
     * Full name of the patient derived from assignment.user
     *
     * @type {string}
     * @memberof CalendarEventDto
     */
    userFullName: string | null;
}
